import { appendCacheBuster } from './append-cache-buster';

/** Shape of the Filepond onChange payload the logo upload produces. */
type LogoUploadPayload =
  | {
      url?: string;
      pictureId?: string;
      data?: unknown;
      files?: unknown[];
    }
  | undefined
  | null;

/**
 * Resolve the URL to store in the `logo` form field after a successful Filepond
 * upload. Returns a cache-busted URL when the upload produced one, otherwise
 * `null` (caller should not touch the field). Mirrors the brandMomentUrl path:
 * a fresh `?v=` token forces the browser/CDN to refetch a same-name re-upload.
 */
export const resolveUploadedLogoUrl = (
  payload: LogoUploadPayload,
  version?: string | number
): string | null => {
  const url = payload?.url;
  if (!url) {
    return null;
  }
  return version === undefined
    ? appendCacheBuster(url)
    : appendCacheBuster(url, version);
};
